/**
 * State for a StopoverHotels
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	filters: number;
	hotels: any;
	feature_hotels: any;
	stopover: any;
	city_id: string;
}

export const initialState: State = {
	loading: false,
	filters: null,
	stopover: null,
	hotels: [],
	feature_hotels: [],
	city_id: null
};
